import { cn } from '@/lib/utils'

type ButtonVariant = 'blaze' | 'ink' | 'paper'
type ButtonSize = 'sm' | 'md' | 'lg'
type ButtonShadow = 'ink' | 'blaze' | 'paper' | 'none'

interface ButtonClassOptions {
    variant?: ButtonVariant
    size?: ButtonSize
    shadow?: ButtonShadow
    className?: string
}

const variants: Record<ButtonVariant, string> = {
    blaze: 'border-ink bg-blaze text-ink',
    ink: 'border-ink bg-ink text-paper',
    paper: 'border-ink bg-paper text-ink'
}

const sizes: Record<ButtonSize, string> = {
    sm: 'h-11 px-4 text-[0.9375rem]',
    md: 'h-13 px-5 text-base sm:h-14 sm:px-6 sm:text-lg',
    lg: 'h-14 px-6 text-lg sm:h-16 sm:px-8 sm:text-xl'
}

const shadows: Record<ButtonShadow, string> = {
    ink: 'shadow-[4px_4px_0_0_var(--color-ink)] hover:shadow-[6px_6px_0_0_var(--color-ink)]',
    blaze: 'shadow-[4px_4px_0_0_var(--color-blaze)] hover:shadow-[6px_6px_0_0_var(--color-blaze)]',
    paper: 'shadow-[4px_4px_0_0_var(--color-paper)] hover:shadow-[6px_6px_0_0_var(--color-paper)]',
    none: ''
}

// Chunky, tactile buttons: they lift on hover and press flat when clicked.
export const buttonClass = ({ variant = 'blaze', size = 'md', shadow = 'ink', className }: ButtonClassOptions = {}): string => cn(
    'group/button relative inline-flex select-none items-center justify-center gap-2.5 whitespace-nowrap rounded-lg border-2 font-heading font-bold tracking-[-0.01em]',
    'transition-[translate,box-shadow,background-color,color] duration-200 ease-snap',
    'hover:-translate-x-0.5 hover:-translate-y-0.5 active:translate-x-[3px] active:translate-y-[3px] active:shadow-none',
    'disabled:pointer-events-none disabled:opacity-60',
    variants[variant],
    sizes[size],
    shadows[shadow],
    className
)

export const arrowClass = 'size-5 shrink-0 transition-transform duration-300 ease-snap group-hover/button:translate-x-1'
